<div class="cart-page">
    <!-- =====================================================
         HEADER
    ====================================================== -->
    <section class="cart-hero">
        <div class="cart-hero__content">
            <p class="cart-eyebrow">
                MI COMPRA
            </p>
            <h1>
                Tu <span class="nina-brand-italic">carrito</span>
            </h1>
            <p class="cart-hero__subtitle" *ngIf="productsCart.length > 0">
                Revisa tus productos antes de continuar con tu pedido.
            </p>
            <p class="cart-hero__subtitle" *ngIf="productsCart.length === 0">
                Tu carrito está esperando algo delicioso.
            </p>
        </div>
    </section>
    <!-- =====================================================
         CARRITO
    ====================================================== -->
    <main class="cart-container">
        <!-- =================================================
             CARRITO CON PRODUCTOS
        ================================================== -->
        <ng-container *ngIf="productsCart.length > 0">
            <div class="cart-layout">
                <!-- =================================================
                     PRODUCTOS
                ================================================== -->
                <section class="cart-products">
                    <div class="cart-section-header">
                        <div>
                            <span class="cart-section-eyebrow">
                                TU PEDIDO
                            </span>
                            <h2>
                                Productos
                            </h2>
                        </div>
                        <span class="cart-item-count">
                            {{ productsCart.length }}
                            {{ productsCart.length === 1 ? 'producto' : 'productos' }}
                        </span>
                    </div>
                    <!-- =================================================
                         GRUPOS
                    ================================================== -->
                    <div class="cart-groups">
                        <article class="cart-product-card" *ngFor="let group of cartView"
                            [class.cart-product-card--promo]="group.type === 'promo'">
                            <!-- =================================================
                                 PRODUCTO NORMAL
                            ================================================== -->
                            <ng-container *ngIf="group.type === 'single'">
                                <div class="cart-product">
                                    <!-- Imagen -->
                                    <div class="cart-product__image-wrapper">
                                        <img class="cart-product__image"
                                            [src]="group.products[0].urlFotoAgrupador || group.products[0].urlFoto"
                                            [defaultImage]="defImgProd" [alt]="
                                                group.products[0].productoAgrupador ||
                                                group.products[0].descripcionProducto ||
                                                group.products[0].producto
                                            ">
                                    </div>
                                    <!-- Información -->
                                    <div class="cart-product__info">
                                        <span class="cart-product__type">
                                            PRODUCTO
                                        </span>
                                        <h3 class="cart-product__name">
                                            {{
                                            group.products[0].productoAgrupador ||
                                            group.products[0].producto
                                            }}
                                        </h3>
                                        <p class="cart-product__description"
                                            *ngIf="group.products[0]?.productoAgrupador">
                                            {{
                                            group.products[0]?.descripcionProducto ||
                                            group.products[0].producto
                                            }}
                                        </p>
                                        <!-- Cantidad -->
                                        <div class="cart-product__quantity">
                                            <span>
                                                Cantidad
                                            </span>
                                            <div class="quantity-control">
                                                <button type="button" class="quantity-button"
                                                    aria-label="Disminuir cantidad"
                                                    (click)="changeQty('restar', group.products[0])">
                                                    <mat-icon>
                                                        remove
                                                    </mat-icon>
                                                </button>
                                                <span class="quantity-value">
                                                    {{ group.products[0].qty }}
                                                </span>
                                                <button type="button" class="quantity-button"
                                                    aria-label="Aumentar cantidad"
                                                    (click)="changeQty('sumar', group.products[0])">
                                                    <mat-icon>
                                                        add
                                                    </mat-icon>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Precio / eliminar -->
                                    <div class="cart-product__aside">
                                        <button type="button" class="delete-product-button"
                                            aria-label="Eliminar producto" (click)="deleteProduct(group.products[0])">
                                            <mat-icon>
                                                delete_outline
                                            </mat-icon>
                                        </button>
                                        <div class="cart-product__price">
                                            <span>
                                                Total
                                            </span>
                                            <!-- Producto con descuento -->
                                            <ng-container *ngIf="
                                                    hasDiscount(group.products[0]);
                                                    else normalProductPrice
                                                ">
                                                <del>
                                                    {{
                                                    getOriginalPrice(group.products[0])! *
                                                    group.products[0].qty
                                                    | currency:'USD':'symbol':'1.0-0'
                                                    }}
                                                </del>
                                                <strong class="cart-product__price--promo">
                                                    {{
                                                    group.total
                                                    | currency:'USD':'symbol':'1.0-0'
                                                    }}
                                                </strong>
                                            </ng-container>
                                            <!-- Producto sin descuento -->
                                            <ng-template #normalProductPrice>
                                                <strong>
                                                    {{
                                                    group.total
                                                    | currency:'USD':'symbol':'1.0-0'
                                                    }}
                                                </strong>
                                            </ng-template>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <!-- =================================================
                                 PROMOCIÓN
                            ================================================== -->
                            <ng-container *ngIf="group.type === 'promo'">
                                <!-- Header promo -->
                                <div class="promo-header">
                                    <div class="promo-header__info">
                                        <span class="promo-badge">
                                            PROMOCIÓN
                                        </span>
                                        <div>
                                            <h3>
                                                {{
                                                group.products.length > 1
                                                ? 'Paquete promocional'
                                                : 'Producto promocional'
                                                }}
                                            </h3>
                                            <p>
                                                {{ group.products.length }}
                                                {{
                                                group.products.length === 1
                                                ? 'producto incluido'
                                                : 'productos incluidos'
                                                }}
                                            </p>
                                        </div>
                                    </div>
                                    <button type="button" class="delete-product-button" aria-label="Eliminar promoción"
                                        (click)="deleteProduct(group.products[0])">
                                        <mat-icon>
                                            delete_outline
                                        </mat-icon>
                                    </button>
                                </div>
                                <!-- Productos de la promo -->
                                <div class="promo-products">
                                    <div class="promo-product" *ngFor="let product of group.products">
                                        <!-- Imagen -->
                                        <div class="promo-product__image-wrapper">
                                            <img class="promo-product__image"
                                                [src]="product.urlFotoAgrupador || product.urlFoto"
                                                [defaultImage]="defImgProd" [alt]="
                                                    product.productoAgrupador ||
                                                    product.descripcionProducto ||
                                                    product.producto
                                                ">
                                        </div>
                                        <!-- Información -->
                                        <div class="promo-product__info">
                                            <strong>
                                                {{
                                                product.productoAgrupador ||
                                                product.producto
                                                }}
                                            </strong>
                                            <span *ngIf="product?.productoAgrupador">
                                                {{
                                                product.descripcionProducto ||
                                                product.producto
                                                }}
                                            </span>
                                            <small>
                                                Cantidad: {{ product.qty }}
                                            </small>
                                        </div>
                                        <!-- Precio -->
                                        <div class="promo-product__price">
                                            <!-- Con descuento -->
                                            <ng-container *ngIf="
                                                    hasDiscount(product);
                                                    else promoNormalPrice
                                                ">
                                                <del>
                                                    {{
                                                    product.qty *
                                                    getOriginalPrice(product)!
                                                    | currency:'USD':'symbol':'1.2-2'
                                                    }}
                                                </del>
                                                <strong>
                                                    {{
                                                    product.qty *
                                                    getProductPrice(product)
                                                    | currency:'USD':'symbol':'1.2-2'
                                                    }}
                                                </strong>
                                            </ng-container>
                                            <!-- Sin descuento -->
                                            <ng-template #promoNormalPrice>
                                                <strong>
                                                    {{
                                                    product.qty *
                                                    getProductPrice(product)
                                                    | currency:'USD':'symbol':'1.0-0'
                                                    }}
                                                </strong>
                                            </ng-template>
                                        </div>
                                    </div>
                                </div>
                                <!-- Total promo -->
                                <div class="promo-total">
                                    <span>
                                        Total de la promoción
                                    </span>
                                    <strong>
                                        {{
                                        group.total
                                        | currency:'USD':'symbol':'1.0-0'
                                        }}
                                    </strong>
                                </div>
                            </ng-container>
                        </article>
                    </div>
                </section>
                <!-- =================================================
                     RESUMEN
                ================================================== -->
                <aside class="cart-summary">
                    <div class="summary-card">
                        <div class="summary-card__header">
                            <span class="cart-section-eyebrow">
                                RESUMEN
                            </span>
                            <h2>
                                Tu pedido
                            </h2>
                        </div>
                        <!-- Puntos -->
                        <div class="summary-row summary-row--points" *ngIf="loged">
                            <span>
                                Puntos disponibles
                            </span>
                            <strong>
                                {{ userPointsData ? userPointsData.puntos : 0 }}
                            </strong>
                        </div>
                        <!-- Productos -->
                        <div class="summary-row">
                            <span>
                                Productos
                            </span>
                            <strong>
                                {{
                                total
                                | currency:'USD':'symbol':'1.0-0'
                                }}
                            </strong>
                        </div>
                        <div class="summary-divider"></div>
                        <!-- Total -->
                        <div class="summary-total">
                            <span>
                                Total
                            </span>
                            <strong>
                                {{
                                (total + costoEnvio)
                                | currency:'USD':'symbol':'1.0-0'
                                }}
                            </strong>
                        </div>
                        <!-- =================================================
                             USUARIO LOGUEADO
                        ================================================== -->
                        <ng-container *ngIf="loged">
                            <button class="cart-pay-button" mat-raised-button type="button"
                                [disabled]="productsCart.length <= 0 || (shippeable && !isAddressValid())"
                                (click)="buy()">
                                Pagar
                            </button>
                            <p class="summary-note">
                                Al continuar podrás confirmar los datos de tu pedido.
                            </p>
                        </ng-container>
                        <!-- =================================================
                             USUARIO NO LOGUEADO
                        ================================================== -->
                        <ng-container *ngIf="!loged">
                            <div class="login-summary">
                                <mat-icon>
                                    person_outline
                                </mat-icon>
                                <h3>
                                    Inicia sesión para continuar
                                </h3>
                                <p>
                                    Identifícate para poder realizar tu pedido.
                                </p>
                                <button class="cart-login-button" mat-raised-button type="button"
                                    (click)="summonLogin()">
                                    INICIAR SESIÓN
                                </button>
                            </div>
                        </ng-container>
                    </div>
                </aside>
            </div>
        </ng-container>
        <!-- =================================================
             CARRITO VACÍO
        ================================================== -->
        <section class="empty-cart" *ngIf="productsCart.length === 0">
            <div class="empty-cart__card">
                <img src="../../../assets/img/voidcart.jpg" alt="Carrito vacío" class="empty-cart__image">
                <span class="cart-section-eyebrow">
                    TU CARRITO
                </span>
                <h2>
                    Tu carrito está vacío
                </h2>
                <p>
                    Aún no tienes productos en tu carrito.
                    Explora nuestro catálogo y encuentra algo que te guste.
                </p>
                <button class="empty-cart__button" mat-raised-button type="button"
                    (click)="router.navigate(['/store'])">
                    VER CATÁLOGO
                </button>
            </div>
        </section>
    </main>

</div>